<template>
  <div class="device-detail">
    <BaseSimpleLayout>
      <template #title>端末詳細</template>
      <template v-if="loadingFlag" #main>
        <div class="device-detail-table-line">
          <BaseDataTable :table-data="leftTableData" :label-width="140" />
        </div>
        <div class="device-detail-table-line">
          <BaseDataTable :table-data="rightTableData" :label-width="120" />
        </div>
        <div class="device-detail-button-area">
          <el-button
            v-if="customerId"
            size="large"
            type="info"
            @click="backCustomerDetail"
          >
            顧客管理情報
          </el-button>
          <el-button
            size="large"
            class="unit-master-support-shop-detail-button-list"
            type="info"
            @click="
              router.push(`/device/${store.state.device.detailData.deviceType}`)
            "
          >
            端末一覧
          </el-button>
          <ScreenPermissionGate :code="codeByDeviceType('BTN_DEVICE_VALIDATE')">
            <el-button
              v-if="status === 1"
              size="large"
              type="primary"
              @click="displayVerifyDialog"
            >
              端末検証
            </el-button>
          </ScreenPermissionGate>
          <ScreenPermissionGate :code="codeByDeviceType('BTN_EDIT')">
            <el-button
              size="large"
              type="success"
              @click="router.push('/device/edit')"
            >
              編集
            </el-button>
          </ScreenPermissionGate>
          <ScreenPermissionGate
            :code="codeByDeviceType('BTN_VIEW_SHIPMENT_DETAIL')"
          >
            <el-button
              v-if="status === 3"
              size="large"
              type="primary"
              @click="router.push('/ship/' + shipId)"
            >
              出荷詳細
            </el-button>
          </ScreenPermissionGate>
          <ScreenPermissionGate :code="codeByDeviceType('BTN_SIM_OPERATION')">
            <el-button size="large" type="warning" @click="displaySimOperate">
              SIM操作
            </el-button>
          </ScreenPermissionGate>
          <ScreenPermissionGate :code="codeByDeviceType('BTN_MARK_UNUSABLE')">
            <el-button
              v-if="status < 3"
              size="large"
              type="danger"
              @click="stopDialogVisible = true"
            >
              使用不可
            </el-button>
          </ScreenPermissionGate>
          <ScreenPermissionGate :code="codeByDeviceType('BTN_REUSE')">
            <el-button
              v-if="status === 5"
              size="large"
              type="primary"
              @click="restartDialogVisible = true"
            >
              再利用
            </el-button>
          </ScreenPermissionGate>
          <ScreenPermissionGate :code="codeByDeviceType('BTN_SIM_EXCHANGE')">
            <el-button
              v-if="store.state.device.detailData.deviceType !== 11"
              size="large"
              class="unit-master-support-shop-detail-button-exchange"
              type="info"
              @click="simExchangeDialogVisible = true"
            >
              SIM交換
            </el-button>
          </ScreenPermissionGate>
        </div>
      </template>
    </BaseSimpleLayout>
    <el-dialog v-model="dialogVisible" title="端末検証" width="450px">
      <el-form
        ref="formRef"
        :model="deviceForm"
        :rules="rules"
        size="large"
        label-width="145px"
      >
        <el-form-item
          v-if="!isMccsTypeT(store.state.device.detailData.deviceType)"
          label="SIM番号"
        >
          <el-input v-model="deviceForm.simNumber" disabled />
        </el-form-item>
        <el-form-item label="シリアル番号">
          <el-input v-model="deviceForm.serialCode" disabled />
        </el-form-item>
        <el-form-item
          v-if="store.state.device.detailData.deviceType !== 11"
          label="出荷ファームVer"
          prop="firmVersion"
        >
          <el-input v-model="deviceForm.firmVersion" />
        </el-form-item>
        <el-form-item
          v-if="store.state.device.detailData.deviceType !== 11"
          label="IBバッテリー"
          prop="internalBatteryVoltage"
        >
          <el-input v-model="deviceForm.internalBatteryVoltage" />
        </el-form-item>
        <el-form-item
          v-if="store.state.device.detailData.deviceType !== 11"
          label="Mboot"
          prop="mboot"
        >
          <el-input v-model="deviceForm.mboot" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="large" @click="dialogVisible = false">
          キャンセル
        </el-button>
        <el-button size="large" type="primary" @click="verifyDevice(formRef)">
          登録
        </el-button>
      </template>
    </el-dialog>
    <el-dialog v-model="stopDialogVisible" title="確認" width="400px">
      <span>
        <b>この端末を使用不可にしますか。</b>
      </span>
      <template #footer>
        <el-button size="large" @click="stopDialogVisible = false">
          キャンセル
        </el-button>
        <el-button size="large" type="danger" @click="stopDevice">
          実行
        </el-button>
      </template>
    </el-dialog>
    <el-dialog v-model="restartDialogVisible" title="確認" width="400px">
      <span>
        <b>この端末を利用可能にしますか？</b>
      </span>
      <template #footer>
        <el-button size="large" @click="restartDialogVisible = false">
          キャンセル
        </el-button>
        <el-button size="large" type="primary" @click="restartDevice">
          実行
        </el-button>
      </template>
    </el-dialog>
    <el-dialog v-model="displaySimDialog" title="SIM操作" width="300px">
      <span>
        <b>{{ dialogMessage }}</b>
      </span>
      <template #footer>
        <el-button size="large" @click="displaySimDialog = false">
          キャンセル
        </el-button>
        <el-button size="large" type="primary" @click="simOperate">
          実行
        </el-button>
      </template>
    </el-dialog>
    <el-dialog v-model="simExchangeDialogVisible" title="SIM交換" width="300px">
      <el-form
        ref="simExchangeFormRef"
        :model="simExchangeForm"
        :rules="simExchangeRules"
        size="large"
        label-width="100px"
        class="device-detail-sim-form"
      >
        <el-form-item label="SIM番号" prop="simNumber">
          <el-input
            v-model="simExchangeForm.simNumber"
            @change="changeNumber"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="large" @click="simExchangeDialogVisible = false">
          キャンセル
        </el-button>
        <el-button
          size="large"
          type="primary"
          @click="simExchange(simExchangeFormRef)"
        >
          登録
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
  import { ref, toRefs, watch } from 'vue';
  import { useStore } from 'vuex';
  import router from '@/router';
  import type { FormInstance, FormRules } from 'element-plus';
  import BaseSimpleLayout from '@/components/BaseSimpleLayout.vue';
  import BaseDataTable from '@/components/BaseDataTable.vue';
  import ScreenPermissionGate from '@/components/ScreenPermissionGate.vue';
  import { formatDateTime } from '@/libs/dateFormat';
  import {
    deviceStatus,
    deviceType,
    handlingType,
    isMccsTypeT,
    simCarrier,
    simStatus
  } from '@/libs/device';
  import { ElLoading } from 'element-plus';
  import { DetailTableData } from '@/types/common';
  import { numberRestriction } from '@/libs/restriction';

  const props = defineProps({
    deviceId: {
      type: String,
      required: true
    }
  });
  const store = useStore();
  const formRef = ref<FormInstance>();
  const simExchangeFormRef = ref<FormInstance>();
  const leftTableData = ref<DetailTableData[]>([]);
  const rightTableData = ref<DetailTableData[]>([]);
  const dialogVisible = ref(false);
  const stopDialogVisible = ref(false);
  const restartDialogVisible = ref(false);
  const simExchangeDialogVisible = ref(false);
  const deviceForm = ref({
    simNumber: 0,
    serialCode: 0,
    firmVersion: '',
    internalBatteryVoltage: '',
    mboot: ''
  });
  const simExchangeForm = ref({
    simNumber: ''
  });
  const rules = ref<FormRules>({
    firmVersion: [{ required: true, message: '出荷ファームVerは必須です。' }],
    internalBatteryVoltage: [
      { required: true, message: 'IBバッテリーは必須です。' }
    ],
    mboot: [{ required: true, message: 'Mbootは必須です。' }]
  });
  const simExchangeRules = ref<FormRules>({
    simNumber: [
      { required: true, message: 'SIM番号は必須です。' },
      {
        min: 11,
        max: 14,
        message: '11-14桁の半角数字で入力してください。',
        trigger: 'blur'
      }
    ]
  });
  const status = ref(0);
  const shipId = ref(0);
  const loadingFlag = ref(false);
  const dialogMessage = ref('');
  const displaySimDialog = ref(false);
  const isActiveSim = ref(false);
  const customerId = ref<string | null>(null);
  const { deviceId } = toRefs(props);
  const codeByDeviceType = (suffix: string) => {
    const type = store.state.device.detailData.deviceType;
    const prefix =
      type === 2 ? 'DEVICE_II' : type === 11 ? 'DEVICE_T' : 'DEVICE_III';
    return `${prefix}-${suffix}`;
  };

  watch(deviceId, () => {
    createDetailData();
  });

  const createDetailData = async () => {
    const loadingInstance = ElLoading.service({ fullscreen: true });
    await Promise.all([
      store.dispatch('device/fetch', deviceId.value),
      store.dispatch('companiesMaster/fetch'),
      store.dispatch('sim/fetchStatus', deviceId.value)
    ]);
    const detailData = store.state.device.detailData;
    leftTableData.value = [
      {
        label: 'ステータス',
        value: deviceStatus[detailData.status]
      },
      {
        label: 'SIMステータス',
        value: simStatus[store.state.sim.status] ?? store.state.sim.status
      },
      {
        label: 'シリアル番号',
        value: detailData.serialCode
      },
      {
        label: '製造番号',
        value: detailData.deviceCode ? detailData.deviceCode : '-'
      },
      {
        label: '端末タイプ',
        value: deviceType[detailData.deviceType]
      },
      {
        label: 'マイナーVer.',
        value: detailData.deviceMinorVersion
      },
      {
        label: '品名',
        value: detailData.itemName
      },
      {
        label: 'SIMキャリア',
        value: simCarrier[detailData.simCarrier] ?? ''
      },
      {
        label: 'SIMプラン',
        value: detailData.simPlan
      },
      ...(isMccsTypeT(detailData.deviceType)
        ? []
        : [
            {
              label: 'SIM番号',
              value: detailData.simNumber
            }
          ]),
      {
        label: 'IMSI',
        value: detailData.simImsi
      },
      {
        label: '出荷ファームVer',
        value: detailData.firmVersion
      },
      {
        label: '出荷コンフィグ',
        value: detailData.configName ? detailData.configName : '-'
      },
      {
        label: 'IBバッテリー',
        value: detailData.internalBatteryVoltage
          ? detailData.internalBatteryVoltage
          : '-'
      },
      {
        label: 'Mboot',
        value: detailData.mboot ? detailData.mboot : '-'
      },
      {
        label: '設定ID',
        value: detailData.deviceSettingUser ? detailData.deviceSettingUser : '-'
      },
      {
        label: '設定パスワード',
        value: detailData.deviceSettingPassword
          ? detailData.deviceSettingPassword
          : '-'
      }
    ];
    rightTableData.value = [
      {
        label: '出荷ID',
        value: detailData.shipId ? detailData.shipId : '-'
      },
      {
        label: 'MSPF登録ID',
        value: detailData.deviceId ? detailData.deviceId : '-'
      },
      {
        label: '取扱',
        value: handlingType[detailData.handlingType]
      },
      {
        label: '確定端末',
        value: detailData.orderCompanyName ? detailData.orderCompanyName : '-'
      },
      {
        label: '備考',
        value: detailData.note
      },
      {
        label: '更新者',
        value: detailData.updateUserName
      },
      {
        label: '更新日時',
        value: formatDateTime(Number(detailData.updatedAt))
      }
    ];
    status.value = detailData.status;
    shipId.value = detailData.shipId;
    isActiveSim.value = ['ACTIVATED', 'active'].includes(
      store.state.sim.status
    );
    customerId.value = store.state.management.customerId;
    loadingInstance.close();
    loadingFlag.value = true;
  };
  const displayVerifyDialog = () => {
    const detailData = store.state.device.detailData;
    deviceForm.value.simNumber = detailData.simNumber;
    deviceForm.value.serialCode = detailData.serialCode;
    deviceForm.value.firmVersion = detailData.firmVersion;
    deviceForm.value.internalBatteryVoltage = detailData.internalBatteryVoltage;
    deviceForm.value.mboot = detailData.mboot;
    dialogVisible.value = true;
  };
  const verifyDevice = async (formEl: FormInstance | undefined) => {
    if (!formEl) return;
    await formEl.validate(async (valid) => {
      if (!valid) {
        return false;
      }
      const loadingInstance = ElLoading.service({ fullscreen: true });
      await store.dispatch('device/verify', {
        id: deviceId.value,
        firmVersion: deviceForm.value.firmVersion,
        mboot: deviceForm.value.mboot,
        internalBatteryVoltage: deviceForm.value.internalBatteryVoltage
      });
      dialogVisible.value = false;
      router.push(`/device/${store.state.device.detailData.deviceType}`);
      loadingInstance.close();
    });
  };
  const stopDevice = async () => {
    const loadingInstance = ElLoading.service({ fullscreen: true });
    await store.dispatch('device/stop', deviceId.value);
    stopDialogVisible.value = false;
    await createDetailData();
    loadingInstance.close();
  };
  const restartDevice = async () => {
    const loadingInstance = ElLoading.service({ fullscreen: true });
    await store.dispatch('device/restart', deviceId.value);
    restartDialogVisible.value = false;
    await createDetailData();
    loadingInstance.close();
  };
  const displaySimOperate = () => {
    const simText = isActiveSim.value ? '休止' : '開通';
    dialogMessage.value = 'SIMを ' + simText + ' しますがよろしいですか？';
    displaySimDialog.value = true;
  };
  const simOperate = async () => {
    const loadingInstance = ElLoading.service({ fullscreen: true });
    if (isActiveSim.value) {
      await store.dispatch('sim/stop', deviceId.value);
    } else {
      await store.dispatch('sim/active', {
        deviceId: deviceId.value,
        isTimeKeepStart: false
      });
    }
    displaySimDialog.value = false;
    await createDetailData();
    loadingInstance.close();
  };
  const simExchange = async (formEl: FormInstance | undefined) => {
    if (!formEl) return;
    await formEl.validate(async (valid) => {
      if (!valid) {
        return false;
      }
      await store.dispatch('device/exchange', {
        deviceId: deviceId.value,
        sim: simExchangeForm.value.simNumber
      });
      simExchangeDialogVisible.value = false;
    });
  };
  const changeNumber = () => {
    simExchangeForm.value.simNumber = numberRestriction(
      simExchangeForm.value.simNumber
    );
  };
  const backCustomerDetail = () => {
    router.push('/management/' + customerId.value);
  };
  createDetailData();
</script>
<style lang="scss">
  .device-detail {
    .main-container {
      width: 900px;
    }
    .device-detail-table-line {
      width: 400px;
      margin: 0px 25px 20px;
      float: left;
    }
    .device-detail-button-area {
      clear: left;
      margin: 20px 0px;
    }
    form {
      width: 350px;
    }
    .dialog-title {
      font-weight: 600;
    }
    .el-input.is-disabled {
      .el-input__inner {
        color: #606266;
      }
    }
    .el-button {
      font-weight: 600;
    }
    .device-detail-sim-form {
      width: 225px;
    }
  }
</style>
